(function ($, Global) {
	var ModalDevisComponent = function (model) {
		this.model = model;
	};

	ModalDevisComponent.prototype.initEvents = function () {
		this.publishers();
	}

	ModalDevisComponent.prototype.publishers = function () {
		var self = this;

		$(document).on('change', '.form-destinataires input[type="checkbox"]', function () {
			var $this = $(this);

			if ($this.prop('checked')) {
				var $otherCheckbox = $('.form-destinataires input[type="checkbox"]').not(this);
				var $otherCheckboxParent = $otherCheckbox.parent();

				$otherCheckbox.checked(false);
				$otherCheckboxParent.removeClass('check');

				if ($otherCheckboxParent.attr('data-toggle')) {
					$('.collapse').collapse('hide');
				}

				if ($this.parent().attr('data-toggle')) {
					$('.collapse').collapse('show');
				}
			} 

			$('.form-destinataires input[type="checkbox"]').not(this)
		});

		$(document).on('click', '.modal-devis .btn-primary', function () {
			var $this = $(this);
			var $form = $('.modal-devis form');
			var data = $form.serializeJson();
			
			var $chkboxAutrePersonne = $('input[name="Gestionnaire_contactDifferent"]');
			data['Gestionnaire_contactDifferent'] = $chkboxAutrePersonne.is(':checked');

            $.Topic('loader-show').publish('.modal-devis .modal-content');

			self.model.extension(data, $form, function () {
                $.Topic('loader-hide').publish('.modal-devis .loading');
				$('.modal-devis').modal('hide');
				$this.attr('disabled', 'true');
			});
		});
	}

	Global.ModalDevisComponent = ModalDevisComponent;
}(jQuery, window));